import { all } from "@redux-saga/core/effects";
import { configsSagas } from "modules/PrimaryKey/services/PrimaryKey/sagas";

export function* primaryKeySagas() {
    yield all([
        configsSagas(),
    ]);
}